// Module
var code = "<h1 id=\"settings\">Settings</h1> <p>This is where the tenant organization Contact Information, Website Image Assets, Document Assets, and Letterhead Logo are set.</p> <p><em>Note</em>: If white labeling is turned off, no image assets can be added.</p> ";
// Exports
module.exports = code;